import { Box, FormControl, Radio, RadioGroup } from "@mui/material";
import React, { ChangeEvent, FC, useEffect, useState } from "react";

import GenericCarousel from "./GenericCarousel";
import { IOptionGeneric } from "../../shared/interface";
import { MyFormControlWhiteLabel } from "..";

interface ISelectableTimesProps {
  value?: string;
  options: IOptionGeneric[];
  onSelected?: (option: IOptionGeneric) => void;
  setValue?: any;
  carousel?: boolean;
  isSelectable?:boolean
  isDashboard?:boolean;
}

const FormControlStyles= {
  "textTransform": "uppercase",
  "fontFamily": "geograph-regular",
  "p": 0,
  "height": "35px",
  "& .MuiTypography-root": { lineHeight: "16px" },
  "width": "100%",
  "textAlign": "center",
};
const SelectableTimes: FC<ISelectableTimesProps> = ({
  value,
  options,
  onSelected,
  isDashboard,
  carousel = false,
  isSelectable=true,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleOptions, setVisibleOptions] = useState(options.slice(0, 6));

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const option = options.find((item) => item.value === e.target.value);

    onSelected && onSelected(option as IOptionGeneric);
  };


  function splitArray(arr: IOptionGeneric[]) {
    const result = [];

    for (let i = 0; i < arr.length; i += 6) {
      result.push(arr.slice(i, i + 6));
    }

    return result;
  }

  useEffect(()=>{
    setVisibleOptions(splitArray(options)[0]);
  }, [options]);

  const handleNext = () => {
    if (currentIndex === Math.ceil(options?.length / 6) - 1) {
      setCurrentIndex(0);
      setVisibleOptions(splitArray(options)[0]);
    } else {
      setVisibleOptions(splitArray(options)[currentIndex + 1]);
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handleBack = () => {
    if (currentIndex === 0) {
      setCurrentIndex(Math.ceil(options?.length / 6) - 1);
      setVisibleOptions(splitArray(options)[Math.ceil(options?.length / 6) - 1]);
    } else {
      setCurrentIndex(currentIndex - 1);
      setVisibleOptions(splitArray(options)[currentIndex - 1]);
    }
  };

  return (
    <FormControl sx={{ display: "grid" }}>
      <RadioGroup
        value={value}
        name="card-radio-times"
        className="!grid"
        onChange={handleChange}
      >
        {carousel && options.length > 6 ? (
          <GenericCarousel
            optionsLength={options.length}
            currentIndex={currentIndex}
            handleNext={handleNext}
            handleBack={handleBack}
            itemsPerPage={6}
          >
            <Box className="grid grid-cols-2 gap-2 my-[0.8rem] justify-center col-span-10">
              {visibleOptions.map((item) => (
                <MyFormControlWhiteLabel
                  sx={FormControlStyles}
                  key={item.value}
                  value={item.value}
                  disabled={!isSelectable ? !isSelectable : item.disabled}
                  control={<Radio />}
                  label={item.label}
                  checked={item.value === value}
                />
              ))}
            </Box>
          </GenericCarousel>
        ) : (
          <Box className={isDashboard ?
            "flex flex-col gap-2 w-full":
            "grid grid-cols-2 gap-2 my-[0.8rem] justify-center"}
          >
            {options.map((item) => (
              <MyFormControlWhiteLabel
                sx={FormControlStyles}
                key={item.value}
                value={item.value}
                disabled={!isSelectable ? !isSelectable : item.disabled}
                control={<Radio />}
                label={item.label}
                checked={item.value === value}
              />
            ))}
          </Box>
        )}
      </RadioGroup>
    </FormControl>
  );
};

export default SelectableTimes;
